<template>
  <woot-modal :show="show" :on-close="onClose" size="large">
    <woot-modal-header :header-title="modalTitle" />
    <section class="modal-content space-y-4">
      <div class="grid grid-cols-1 gap-3 text-sm text-slate-600 dark:text-slate-300">
        <div class="flex gap-2">
          <span class="font-medium">{{ $t('BUSINESS_DATA.FILE_SOURCES.NAME') }}:</span>
          <span>{{ fileSource?.name }}</span>
        </div>
        <div class="flex gap-2">
          <span class="font-medium">{{ $t('BUSINESS_DATA.FILE_SOURCES.FILE') }}:</span>
          <span>{{ fileSource?.original_filename }}</span>
        </div>
        <div class="flex gap-2">
          <span class="font-medium">{{ $t('BUSINESS_DATA.FILE_SOURCES.STATUS.LABEL') }}:</span>
          <span>{{ fileSource?.status_display }}</span>
        </div>
      </div>

      <div v-if="error" class="p-3 rounded bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-300 text-sm">
        {{ error }}
      </div>

      <div v-if="isLoading" class="flex items-center justify-center py-12">
        <div class="flex items-center gap-3 text-slate-500 dark:text-slate-400">
          <div class="w-5 h-5 border-2 border-slate-200 dark:border-slate-600 border-t-hichat-500 rounded-full animate-spin"></div>
          <span>{{ $t('BUSINESS_DATA.FILE_SOURCES.LOADING_DETAIL') }}</span>
        </div>
      </div>
      <div v-else class="space-y-3">
        <div class="p-3 rounded bg-slate-50 dark:bg-slate-800/50 text-slate-600 dark:text-slate-300 text-sm">
          {{ $t('BUSINESS_DATA.FILE_SOURCES.RAG_NOTE') }}
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm text-slate-600 dark:text-slate-300">
          <div class="flex gap-2">
            <span class="font-medium">{{ $t('BUSINESS_DATA.FILE_SOURCES.CHUNK_COUNT') }}:</span>
            <span>{{ fileSource?.items_count || 0 }}</span>
          </div>
          <div class="flex gap-2">
            <span class="font-medium">{{ $t('BUSINESS_DATA.FILE_SOURCES.LAST_INGESTED') }}:</span>
            <span>{{ formatDate(fileSource?.last_ingested_at) || '—' }}</span>
          </div>
        </div>
      </div>
    </section>

    <template #footer>
      <div class="flex flex-col sm:flex-row items-center justify-between gap-3">
        <div class="text-xs text-slate-500 dark:text-slate-400 text-center sm:text-left">
          {{ $t('BUSINESS_DATA.FILE_SOURCES.PURGE_HINT') }}
        </div>
        <div class="flex gap-3">
          <woot-button variant="smooth" color-scheme="ghost" @click="onClose">
            {{ $t('COMMON.CLOSE') }}
          </woot-button>
          <woot-button
            variant="smooth"
            color-scheme="alert"
            :loading="isPurging"
            :disabled="(fileSource?.items_count || 0) === 0"
            @click="$emit('purge')"
          >
            {{ $t('BUSINESS_DATA.FILE_SOURCES.PURGE_BUTTON') }}
          </woot-button>
        </div>
      </div>
    </template>
  </woot-modal>
</template>

<script>
export default {
  name: 'FileSourceDetailModal',
  props: {
    show: { type: Boolean, default: false },
    fileSource: { type: Object, default: null },
    items: { type: Array, default: () => [] },
    isLoading: { type: Boolean, default: false },
    isPurging: { type: Boolean, default: false },
    error: { type: String, default: '' },
  },
  emits: ['close', 'purge'],
  computed: {
    modalTitle() {
      return this.$t('BUSINESS_DATA.FILE_SOURCES.DETAIL_TITLE');
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    formatDate(value) {
      if (!value) return '';
      return new Date(value).toLocaleString();
    },
  },
};
</script>
